
// urls
const BASE_URL = "http://localhost:8000/api";

// auth urls
const LOGIN_URL = "/auth/login/";
const LOGOUT_URL = "/auth/logout/";
const REGISTER_URL = "/auth/register/";

// deep blue urls
const EMPLOYEE_URL = "/auth/employee/";
const PROJECT_URL = "/auth/projects/";
const TASK_URL = "/auth/task/";
const COMMENTS_URL = "/auth/comments/";
const REPLY_URL = "/auth/reply/";
const TEAM_URL = "/auth/team/";

export {
BASE_URL,
PROJECT_URL, EMPLOYEE_URL, TASK_URL, COMMENTS_URL,
REPLY_URL, LOGIN_URL,
LOGOUT_URL, REGISTER_URL,
}
